import React from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { firstErrorMessage } from '@/utils/errors';
import findResult from '@/utils/resultsHelper';
import PublicVisibilityFilterToggles from '@/components/buttons/PublicVisibilityFilterToggles';
import Filter from '@/components/Filter';
import { fetchCollectionDatasets, updateCollectionDatasetsFlags, updateCollectionDatasetsFilter } from '../actions';

const CollectionDatasetsFilters = ({
  category,
  className,
  code,
  commonsMode,
  fetchData,
  filterTerm,
  fluid,
  internalFlag,
  isGuest,
  privateFlag,
  publicFlag,
  readErrors,
  updateFilterTerm,
  updateFlags,
}) => (
  <Filter
    fluid={fluid}
    className={clsx('aridhia-datasets-filter', className)}
    filterTerm={filterTerm || ''}
    updateFilter={({ value }) => updateFilterTerm(category, code, value)}
    error={firstErrorMessage(readErrors)}
    onFilter={() => fetchData(category, code, 1)}
    {...!isGuest && {
      label: <PublicVisibilityFilterToggles
        commonsMode={commonsMode}
        entity="datasets"
        privateFlag={privateFlag}
        internalFlag={internalFlag}
        publicFlag={publicFlag}
        updateFlags={(flags) => updateFlags(category, code, flags)}
      />,
    }}
  />
);

const mapStateToProps = ({
  auth: { commonsMode, currentUser },
  collectionDatasets: { collectionDatasets },
}, { category, code }) => {
  const item = findResult(collectionDatasets, category, code) || {
    filter: '',
    internalFlag: false,
    privateFlag: false,
    publicFlag: false,
    readErrors: [],
  };

  return ({
    commonsMode,
    filterTerm: item.filter,
    internalFlag: item.internalFlag,
    isGuest: currentUser ? currentUser.isGuest : true,
    privateFlag: item.privateFlag,
    publicFlag: item.publicFlag,
    readErrors: item.readErrors,
  });
};

const mapDispatchToProps = {
  updateFlags: updateCollectionDatasetsFlags,
  updateFilterTerm: updateCollectionDatasetsFilter,
  fetchData: fetchCollectionDatasets,
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionDatasetsFilters);
